// AUTO-GENERATED — DO NOT EDIT
export const breakpoints = {
    xsm: 425,
    sm: 600,
    md: 768,
    lg: 1024,
    xlg: 1232,
    "nav-break": 768,
} as const;

export type BreakpointsKey = keyof typeof breakpoints;
